<template>
  <div class="home">
    <div class="header"></div>
    <div class="container">
      <div class="row" v-if="language === 'spanish'">
        <div class="col s12 back">
          <p><a @click="home()">Inicio</a> / Aviso de Privacidad</p>
        </div>
        <div class="col s12">
          <p>XIMENA LLAGUNO VIDAL, con domicilio en México D.F., en cumplimiento a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares, su reglamento y los lineamientos y estándares nacionales e internacionales en materia de Protección de Datos Personales, emite el siguiente:</p>
        </div>
        <div class="col s12">
          <h1>Aviso de Confidiencialidad</h1>
        </div>
        <div class="col s12">
          <ol>
            <li>
              <p class="option__title">Datos Personales:</p>
              <p>Para efecto de brindarles a nuestros clientes los productos y servicios que se ofrecen en esta empresa, solicitaremos a nuestros clientes los siguientes datos personales:</p>
              <ul class="ul__margin">
                <li>Nombre: con la finalidad de identificarlo en nuestros contactos.</li>
                <li>Correo electrónico: como medio de contacto para brindar los servicios.</li>
                <li>Teléfono fijo, celular, y domicilio: como medio de contacto para agendar citas, verificar datos, y en general, prestarle nuestros servicios.</li>
                <li>Registro Federal de Causantes: para efectos fiscales.</li>
              </ul>
              <p>Asimismo, en caso de requerir nuestros servicios de confirmación de invitados, solicitaremos nombre y teléfono fijo o celular de sus invitados para poder ponernos en contacto con ellos y brindarle este servicio.</p>
            </li>
            <br>

            <li>
              <p class="option__title">Datos sensibles y datos financieros:</p>
              <p>Con la finalidad de prepararnos para cualquier eventualidad, solicitaremos datos sensibles como son alergias y otras condiciones médicas relevantes que puedan poner en riesgo la salud de sus invitados durante el evento. <br><br> Respecto de los datos financieros, únicamente se solicitarán los necesarios al concretarse la venta a efecto de realizar las transacciones de pago y para efectos fiscales.</p>
              <p></p>
            </li>
            <br>

            <li>
              <p class="option__title">Finalidades de Tratamiento:</p>
              <p>A continuación se citan las finalidades para las cuales efectuamos tratamiento de sus datos antes y durante el evento.</p>
              <br>
              <p>Datos personales del contratante</p>
              <ul>
                <li>Contacto</li>
                <li>Cumplimiento a contratos de prestación de servicios.</li>
              </ul>
              <br>
              <p>Datos financieros del contratante:</p>
              <ul>
                <li>Realizar transacciones de pago</li>
                <li>Para efectos fiscales</li>
              </ul>
              <br>
              <p>Datos personales de los invitados:</p>
              <ul>
                <li>Contacto</li>
                <li>Confirmación de asistencia de invitados al evento.</li>
              </ul>
              <br>
              <p>Datos sensibles del contratante e invitados:</p>
              <ul>
                <li>Conocer alergias y condiciones médicas relevantes que puedan poner en riesgo la salud de los invitados durante el evento.</li>
                <br>
                <p>Tres semanas después de concluido el evento, eliminamos de nuestros registros físicos y electrónicos toda la información personal, financiera y sensible del contratante y sus invitados, a excepción de los datos de contacto del contratante para cualquier seguimiento posterior al evento.</p>
              </ul>
            </li>
            <br>

            <li>
              <p class="option__title">Transferencias:</p>
              <p>Informamos a nuestros clientes que no se realizan transferencias de datos personales, financieros ni sensibles del contratante o sus invitados, con excepción de que exista la expresa solicitud y autorización del mismo.</p>
            </li>
            <br>

            <li>
              <p class="option__title">Medios y/o procedimiento para el ejercicio de Derechos ARCO:</p>
              <p>Usted podrá limitar el tratamiento de sus datos, uso, divulgación, oponerse a la transferencia de los mismos o ejercer sus derechos de acceso, rectificación, cancelación u oposición, dirigiéndose directamente a XIMENA LLAGUNO VIDAL a través del correo electrónico: info@ximenallaguno.com</p>
            </li>
            <br>

            <li>
              <p class="option__title">Cambios al Aviso de Privacidad:</p>
              <p>Los cambios a este aviso serán notificados vía correo electrónico. Adicionalmente, usted puede solicitar la versión más actualizada directamente al correo electrónico antes mencionado, o bien consultarla a través de nuestra página de internet: <a @click="home()">www.ximenallaguno.com</a>  </p>
            </li>
          </ol>
        </div>
      </div>

      <div class="row" v-if="language === 'english'">
        <div class="col s12 back">
          <p><a @click="home()">Home</a> / Notice of Privacy</p>
        </div>
        <div class="col s12">
          <p>XIMENA LLAGUNO VIDAL, place of residence México City., in compliance with the Federal Law on the protection of Personal Data in the possession of private parties, its regulation, the guidelines and national and international standards regarding the protection of personal data issues the following:</p>
        </div>
        <div class="col s12">
          <h1>NOTICE OF CONFIDENTIALITY</h1>
        </div>
        <div class="col s12">
          <ol>
            <li>
              <p class="option__title">Personal Data:</p>
              <p>In order to provide our clients with the services and products offered, we will request the following personal data information:</p>
              <ul class="ul__margin">
                <li>Name: with the purpose of identifying the client.</li>
                <li>E-mail: In order to communicate more effectively.</li>
                <li>Land line, cellphone and address: communication means for contact in order to make appointments, verify data, and anything that might be needed to provide an effective experience.</li>
                <li>Federal Taxpayer Registry: for fiscal effects.</li>
              </ul>
              <p>If the confirmation of guests assistance is solicited, we will require the name, land line or cellphone of your guests in order to complete the service.</p>
            </li>
            <br>

            <li>
              <p class="option__title">Sensitive and Financial data:</p>
              <p>With the purpose of being prepared for any eventuality, we will require sensible data like allergies and other relevant medical conditions that might threaten the clients or the guest's health or well-being during the event. <br><br> Regarding the financial data we will solely require the necessary in order to complete the transaction for payment and fiscal purposes.</p>
              <p></p>
            </li>
            <br>

            <li>
              <p class="option__title">Collecting of data:</p>
              <p>The usage of the client's data before and during the event has the following purposes:</p>
              <br>
              <p>The contracting party's personal data:</p>
              <ul>
                <li>Contact.</li>
                <li>The correct completion of a provision of a service contract.</li>
              </ul>
              <br>
              <p>The contracting party's financial data:</p>
              <ul>
                <li>For payment transactions.</li>
                <li>For fiscal effects.</li>
              </ul>
              <br>
              <p>The guest's personal data:</p>
              <ul>
                <li>The assistance confirmation of guests.</li>
              </ul>
              <br>
              <p>The contracting party and guest's sensible data:</p>
              <ul>
                <li>To have knowledge of allergies and relevant medical conditions that might risk the health of the guests during the event.</li>
                <br>
                <p>Three weeks after the event we proceed to delete from our physical and electronic registries all personal, financial and sensible data of the contraction party and its guests, We keep only the contact information for any further monitoring of the event.</p>
              </ul>
            </li>
            <br>

            <li>
              <p class="option__title">Transfers:</p>
              <p>We inform our clients that no personal, financial or sensitive data of the contracting party or guests are transferred in any way unless we have the contracting party´s express request and authorization.</p>
            </li>
            <br>

            <li>
              <p class="option__title">Procedure and means for the exercise of the ARCO rights:</p>
              <p>You will be able to limit the processing of your data. The usage, exposure, transference and exercise your access, rectification, cancelation or opposition rights by communicating directly with XIMENA LLAGUNO VIDAL by e-mail at: info@ximenallaguno.com</p>
            </li>
            <br>

            <li>
              <p class="option__title">Modifications to the Notice of Confidentiality:</p>
              <p>Any modifications this notice of confidentiality migh have will be notified by e-mail. You may request the updated version by e-mail directly or consult it through our web page: <a @click="home()">www.ximenallaguno.com</a>  </p>
            </li>
          </ol>
        </div>
      </div>
    </div>

    <button class="change-language" v-if="language === 'spanish'" @click="changeToEnglish">English</button>
    <button class="change-language" v-if="language === 'english'" @click="changeToSpanish">Español</button>
  </div>
</template>

<script>
export default {
  name: 'Aviso-de-Privacidad',
  data () {
    return {
      language: 'spanish'
    }
  },
  methods: {
    changeToSpanish () {
      this.language = 'spanish'
    },
    changeToEnglish () {
      this.language = 'english'
    },
    home () {
      this.$router.push({name: 'Tool'});
    }
  }
};
</script>

<style lang="scss">
$gray: #e6ddcc;
$pink: #e24a9b;
$white: #ffffff;
$black: #000000;

@font-face {
    font-family: 'Montserrat';
    src: url('../assets/font/Montserrat-Regular.ttf');
}

a {
  cursor: pointer;
}

.home {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  text-align: justify;
  
  .header {
    position: relative;
    height: 10px;
    width: 100%;
    background-color: $pink;
    margin-bottom: 30px;
  }

  .container {
    h1 {
      font-size: 18px;
      font-weight: bold;
      text-transform: uppercase;
      text-align: center;
      color: $pink;
      margin: 20px 0px;
    }

    .back {
      margin-bottom: 20px;

      p {
        font-size: 12px;

        a {
          color: $pink;
        }
      }
    }

    ol {
      padding-left: 15px;

      li {
        .option__title {
          color: $pink;
          font-weight: bold;
          text-transform: uppercase;
          margin-bottom: 10px;
        }

        a {
          color: $pink;
          font-weight: bold;
        }

        .ul__margin {
          margin: 8px 0px;
        }

        ul {
          li {
            margin-left: 20px;
            list-style-type: disc;
          }
        }
      }
    }
  }

  .change-language {
    position: fixed;
    bottom: 5px;
    right: 30px;
    padding: 10px 20px;
    border-radius: 5px;
    font-family: 'Montserrat', sans-serif;
    border: none;
    color: $white;
    background-color: $pink;
    cursor: pointer;
    box-shadow: 0 0 5px black;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AvisoPrivacidad.vue